import { useSpring } from 'react-spring'
import * as React from 'react'

import { LayoutContext, PageType } from '../context/LayoutContext'

const usePageTransition = (pageType: PageType): ReturnType<typeof useSpring> => {
  const { layoutState, dispatchLayoutAction } = React.useContext(LayoutContext)
  const [isAppear, setIsAppear] = React.useState(false)
  const spring = useSpring({
    opacity: isAppear ? 1 : 0,
    onRest: () => {
      if (layoutState.transitionType) {
        const transition = layoutState.transitionType
        switch (transition.state) {
          case 'pageWillAppear':
            if (transition.to === pageType) {
              dispatchLayoutAction({ type: 'updateTransition', value: 'pageDidAppear' })
            }
            break
          case 'pageWillDisappear':
            if (transition.from === pageType) {
              window.scrollTo(0, 0)
              dispatchLayoutAction({ type: 'updateTransition', value: 'pageDidDisappear' })
            }
            break
          default:
            break
        }
      }
    },
  })

  React.useEffect(() => {
    const transition = layoutState.transitionType
    if (transition) {
      switch (transition.state) {
        case 'pageWillAppear':
          setIsAppear(true)
          break
        case 'pageWillDisappear':
          setIsAppear(false)
          break
        default:
          break
      }
    }
  }, [layoutState.transitionType])

  return spring
}

export default usePageTransition
